import { API_BASE_URL } from '../settings';

export const authenticate = (email, password) => {
  console.log(JSON.stringify({ email: email, password: password }));
  return fetch(API_BASE_URL + 'authenticate', {
    headers: {
      'Content-Type': 'application/json'
    },
    method: 'POST',
    body: JSON.stringify({ email: email, password: password })
  }).then(res => {
    return res.json();
  });
};

export const signOut = () => {
  return fetch(API_BASE_URL + 'signout', {
    headers: {
      'Content-Type': 'application/json'
    },
    method: 'POST'
  }).then(res => {
    return res.json();
  });
};


// WEBPACK FOOTER //
// ./src/services/authentication.services.js